import React from 'react';
import { Avatar } from '@mui/material';
import { getInitialsFromFullName } from '@pv/common/utils';

interface UserAvatarProps {
  fullName?: string;
  gravatarUrl?: string;
  color?: string;
  textColor?: string;
}

export const UserAvatar = ({
  fullName = '',
  gravatarUrl = '',
  color = 'primary.main',
  textColor,
}: UserAvatarProps) => {
  const initials = getInitialsFromFullName(fullName);

  return (
    <Avatar
      alt={fullName}
      title={fullName}
      src={gravatarUrl}
      sx={{ bgcolor: color, fontWeight: 500, color: textColor }}
    >
      {initials}
    </Avatar>
  );
};
